'use client';

import { useEffect } from 'react';
import { registerStoreConfig } from '@develos/next-library';
import { storeConfig } from '@/store';

const ClientStoreInitializer = () => {
  useEffect(() => {
    registerStoreConfig(storeConfig);
  }, []);

  return null;
};

export default ClientStoreInitializer;
